import ImageLinkPreview from './ImageLinkPreview';
import {isImageUrl, parseTextWithLinks} from './utils';

type LinkifiedTextProps = {
  text?: string;
  fallback?: string;
};

const LinkifiedText: React.FC<LinkifiedTextProps> = ({text, fallback = 'بدون توضیحات'}) => {
  if (!text) {
    return fallback;
  }

  return parseTextWithLinks(text).map((part, index) => {
    if (part.type === 'link' && part.href) {
      return (
        <span
          key={`link-${index}`}
          className="inline-flex min-w-0 max-w-full flex-col items-start align-top"
        >
          <a
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
            title={part.value}
            className="block max-w-full truncate text-orange-main underline"
          >
            {part.value}
          </a>
          {isImageUrl(part.href) ? <ImageLinkPreview href={part.href} /> : null}
        </span>
      );
    }

    return <span key={`text-${index}`}>{part.value}</span>;
  });
};

export default LinkifiedText;
